import { render, staticRenderFns } from "./msw-create-customer.vue?vue&type=template&id=1397d2f4&"
import script from "./msw-create-customer.vue?vue&type=script&lang=ts&"
export * from "./msw-create-customer.vue?vue&type=script&lang=ts&"
import style0 from "./msw-create-customer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports